// import React, { useEffect, useRef, useState, useContext } from "react";
// import { Link, useHistory } from "react-router-dom";
// import Swal from "sweetalert2";
// import Button from "react-bootstrap/Button";
// import Modal from "react-bootstrap/Modal";
// import { LanguageContext } from "../Components/LanguageContext";
// import { useTheme } from "../../ThemeContext";
// import { BsPerson, BsPencilSquare, BsCheckCircleFill } from 'react-icons/bs';
// import { LuIndianRupee } from "react-icons/lu";
// import { apiRequest } from "../../apiService/allApi";
// import Rightcontainer from "../Components/Rightcontainer";

// // Keep your CSS imports
// import "../css/layout.css";
// import css from "../css/Profile.module.css";
// import "../css/kyc.css";
// import "../css/Loader.css";

// const Profile1 = ({ profile }) => {
//   // --- KEEPING ALL YOUR EXISTING LOGIC & STATE UNTOUCHED ---
//   const translations = {
//     hi: { wallet: 'वॉलेट', refer: 'किसी मित्र का रेफर कोड इस्तेमाल करे', win: 'पैसा जिता', game: 'गेम खेला', referEarn: 'रेफरल कमाई', referPerson: 'आमंत्रित किये दोस्त' },
//     en: { wallet: 'My Wallet', refer: 'Use Refer Code', Win: 'Coin Won', game: 'Battle Played', referEarn: 'Referral Earning', referPerson: 'Referred Players' },
//   };

//   const { language } = useContext(LanguageContext);
//   const baseUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
//   const [show, setShow] = useState(false);
//   const [show1, setShow1] = useState(false);
//   const handleClose = () => setShow1(false);
//   const handleShow = () => setShow1(true);
//   const [referral, setCode] = useState("");
//   const [Id, setId] = useState(null);
//   const [msg, setMsg] = useState("");
//   const [portcss, setPortcss] = useState(css.active_tab);
//   const [portcss1, setPortcss1] = useState(css.inactive_tab);
//   const [holder_name, setHolder_name] = useState();
//   const [account_number, setAccount_number] = useState();
//   const [ifsc_code, setIfsc_code] = useState();
//   const [upi_id, setUpi_id] = useState();
//   const [isLoading, setIsloading] = useState(false);
//   const [showKyc, setShowKyc] = useState(false);
//   const [process1, setProcesss] = useState(false);

//   const udata = localStorage.getItem("udata");
//   const profileData = JSON.parse(udata);
//   const siteData = localStorage.getItem("sitSetting");
//   const SData = JSON.parse(siteData);

//   const handleCloseKyc = () => setShowKyc(false);
//   const handleShowKyc = () => setShowKyc(true);
//   const [inputOpen, setInputOpen] = useState(false);
//   const [Email, setEmail] = useState(null);
//   const toggleInput = () => setInputOpen(!inputOpen);
//   const history = useHistory();

//   // --- ALL YOUR FUNCTIONS (NOT MODIFIED) ---
//   const logout = async () => {
//     localStorage.clear();
//     let access_token = localStorage.getItem("token");
//     const headers = { Authorization: `Bearer ${access_token}` };
//     await apiRequest(`me`, "GET", null, headers)
//       .then(() => { /* logic */ })
//       .catch((e) => {
//         if (e.response?.status === 401) {
//           localStorage.removeItem("token");
//           window.location.reload();
//           history.push("/login");
//         }
//       });
//   };

//   const UpdateEmail = async () => {
//     const access_token = localStorage.getItem("token");
//     const headers = { Authorization: `Bearer ${access_token}` };
//     if (Email != null) {
//       try {
//         const respone = await apiRequest(`user/profile/edit`, "PATCH", { Email }, headers);
//         if (respone.data.status === false) {
//           Swal.fire({ title: respone.data.msg, icon: "error" });
//         } else {
//           setEmail(respone.data); setInputOpen(false);
//           Swal.fire({ title: respone.data.msg, icon: "success" });
//         }
//       } catch (error) { }
//     } else {
//       Swal.fire({ title: "Please enter your Email", icon: "error" });
//     }
//   };

//   const [Name, setName] = useState(null);
//   const UpdateProfile = async () => {
//     const access_token = localStorage.getItem("token");
//     const headers = { Authorization: `Bearer ${access_token}` };
//     if (Name != null) {
//       const respone = await apiRequest(`user/profile/edit`, "PATCH", { Name }, headers);
//       if (respone.data.status === false) {
//         Swal.fire({ title: respone.data.msg, icon: "error" });
//       } else {
//         setName(respone.data);
//         Swal.fire({ title: respone.data.msg, icon: "success" });
//       }
//     }
//   };

//   const [total, setTotal] = useState();
//   const TotalGame = async () => {
//     let access_token = localStorage.getItem("token");
//     let userId = localStorage.getItem("userId");
//     const headers = { Authorization: `Bearer ${access_token}` };
//     try {
//       const res = await apiRequest(`total/user/all/${userId}`, "GET", null, headers);
//       if (res.data) setTotal(res.data);
//     } catch (e) { }
//   };

//   const Result = async (file) => {
//     if (file) {
//       const access_token = localStorage.getItem("token");
//       const headers = { Authorization: `Bearer ${access_token}` };
//       const formData = new FormData();
//       formData.append("avatar", file);
//       await apiRequest(`users/me/avatar`, "POST", formData, headers);
//     }
//   };

//   const Kyc = () => setShowKyc(true);

//   const [AadharNum, setAadharNum] = useState("");
//   const [userAdharData, setUserAdharData] = useState("");
//   const handleAdharChnage = (e) => setAadharNum(e.target.value);

//   const AdharNumber = async (e) => {
//     setIsloading(true); e.preventDefault();
//     if (/^[0-9]{12}$/.test(AadharNum)) {
//       const access_token = localStorage.getItem("token");
//       const headers = { Authorization: `Bearer ${access_token}` };
//       const data = { aadharNumber: AadharNum };
//       try {
//         const res = await apiRequest("aadharcard-auto", "POST", data, headers);
//         setUserAdharData(res?.data);
//         setIsloading(false);
//         if (res.data.status === false) setMsg(res?.data?.msg);
//         else setMsg(res?.data?.data?.message);
//       } catch (error) { console.log(error); }
//     } else {
//       Swal.fire({ icon: "error", title: "Invalid Aadhar", text: "12-digit required" });
//       setIsloading(false);
//     }
//   };

//   const [AadharOtp, setAadharOtp] = useState("");
//   const [isLoading1, setIsloading1] = useState(false);
//   const handleAdharOtpChnage = (e) => setAadharOtp(e.target.value);

//   const AdharOtpFunc = async (e) => { // Renamed slightly to avoid collision with state
//     setIsloading1(true);
//     const access_token = localStorage.getItem("token");
//     const headers = { Authorization: `Bearer ${access_token}` };
//     const data = { aadharNumber: AadharNum, otp: AadharOtp, Email: Email, transaction_id: userAdharData.data?.ref_id };
//     try {
//       const res = await apiRequest(`aadharcard-auto-verify`, "POST", data, headers);
//       setIsloading1(false);
//       if (res.data.status === false) setMsg(res.data?.msg);
//       else window.location.reload();
//     } catch (e) { console.log(e); }
//   };

//   let aadharProcess = useRef(false);
//   const [Names, setNames] = useState("");
//   const [DOB, setDob] = useState("");
//   const [frontLoaded, setFrontLoaded] = useState(null);
//   const [backLoaded, setBackLoaded] = useState(null);

//   const handleSubmitdata = async (e) => {
//     e.preventDefault();
//     if (!Names || !DOB || !frontLoaded || !backLoaded || !AadharNum) {
//       alert("All fields required"); return;
//     }
//     if (aadharProcess.current === false) {
//       setProcesss(true); aadharProcess.current = true;
//       const formData = new FormData();
//       formData.append("Name", Names); formData.append("DOB", DOB);
//       formData.append("front", frontLoaded[0]); formData.append("back", backLoaded[0]);
//       formData.append("Number", AadharNum); formData.append("Email", Email);
//       const access_token = localStorage.getItem("token");
//       const headers = { Authorization: `Bearer ${access_token}` };
//       const res = await apiRequest(`aadharcard`, "POST", formData, headers);
//       if (res.data.status === false) {
//         Swal.fire({ title: res.data.msg, icon: "error" }).then(() => handleCloseKyc());
//       } else {
//         Swal.fire({ title: "KYC submitted", icon: "success" }).then(() => handleCloseKyc());
//         history.push("/Profile");
//       }
//       aadharProcess.current = false; setProcesss(false);
//     }
//   };

//   useEffect(() => { TotalGame(); }, []);

//   const [isValidEmail, setIsValidEmail] = useState(true);
//   const handleEmailChange = (e) => {
//     const newEmail = e.target.value;
//     setEmail(newEmail);
//     const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
//     setIsValidEmail(emailRegex.test(newEmail) && newEmail.toLowerCase().endsWith(".com"));
//   };

//   const theme = localStorage.getItem('theme');
//   const styles = {
//     backgroundColor: theme === 'light' ? '#f0f2f5' : '#0f0f1b',
//     color: theme === 'light' ? '#333' : '#fff',
//   };

//   // --- NEW UI RENDERING ---
//   return (
//     <>
//       <div className="leftContainer mt-4 mb_space" style={{ ...styles, minHeight: "100vh" }}>
//         <div className="profile_page_new pt-4 px-3">

//           {/* 1. Header Card (Premium Look) */}
//           <div className="premium_card mb-4">
//             <div className="card_accent"></div>
//             <div className="d-flex align-items-center p-3">
//               <div className="avatar_container position-relative">
//                 <label style={{ cursor: 'pointer' }}>
//                   <input type="file" className="d-none" accept="image/*" onChange={(e) => Result(e.target.files[0])} />
//                   <img
//                     src={profileData?.avatar ? `${baseUrl}/${profileData.avatar}` : "./images/avatars/Avatar5.png"}
//                     alt="User"
//                     className="main_profile_img"
//                   />
//                   <div className="camera_badge"><BsPencilSquare size={12} /></div>
//                 </label>
//               </div>
//               <div className="ms-3 flex-grow-1">
//                 {portcss === css.active_tab ? (
//                   <div className="d-flex align-items-center">
//                     <h2 className="profile_name_text mb-0">{profile?.Name || "Player"}</h2>
//                     <BsPencilSquare
//                       className="ms-2 text-warning"
//                       onClick={() => { setPortcss(css.inactive_tab); setPortcss1(css.active_tab); }}
//                       style={{ cursor: 'pointer' }}
//                     />
//                   </div>
//                 ) : (
//                   <div className="d-flex">
//                     <input
//                       type="text"
//                       className="edit_name_input"
//                       value={Name}
//                       onChange={(e) => setName(e.target.value)}
//                     />
//                     <button className="btn_save_name ms-2" onClick={() => { setPortcss(css.active_tab); setPortcss1(css.inactive_tab); UpdateProfile(); }}>
//                       <BsCheckCircleFill />
//                     </button>
//                   </div>
//                 )}
//               </div>
//               <div className="kyc_badge_area">
//                 {profile?.verified === "verified" ? (
//                   <span className="badge_verified">VERIFIED</span>
//                 ) : (
//                   <span className="badge_pending" onClick={Kyc}>UNVERIFIED</span>
//                 )}
//               </div>
//             </div>
//           </div>

//           {/* 2. Stats Grid */}
//           <div className="stats_grid_premium mb-4">
//             <div className="stat_item blue_glow">
//               <img src="/images/crossswords.png" alt="" />
//               <div className="stat_text">
//                 <span className="stat_label">{translations[language].game}</span>
//                 <h3 className="stat_val">{String(total?.stringValue ?? total ?? "0")}</h3>
//               </div>
//             </div>
//             <div className="stat_item gold_glow">
//               <img src="/Coin without Glow.gif" alt="" />
//               <div className="stat_text">
//                 <span className="stat_label">{translations[language].Win}</span>
//                 <h3 className="stat_val">₹{String(profile?.wonAmount?.stringValue ?? "0")}</h3>
//               </div>
//             </div>
//             {/* <div className="stat_item green_glow">
//                 <img src="/images/refer1.png" alt="" />
//                 <div className="stat_text">
//                   <span className="stat_label">Referral</span>
//                   <h3 className="stat_val">₹{String(profile?.referral_earning?.stringValue ?? "0")}</h3>
//                 </div>
//              </div> */}
//             {/* <div className="stat_item purple_glow">
//                 <img src="/images/cash-withdrawal.png" alt="" />
//                 <div className="stat_text">
//                   <span className="stat_label">Withdrawal</span>
//                   <h3 className="stat_val">₹{String(profile?.totalWithdrawl?.stringValue ?? "0")}</h3>
//                 </div>
//              </div> */}
//           </div>

//           {/* 3. Account Details List */}
//           <div className="account_details_card p-3 mb-4">
//             <h4 className="section_title">General Details</h4>

//             <div className="detail_row d-flex justify-content-between align-items-center">
//               <div className="d-flex align-items-center">
//                 <div className="row_icon"><img src="/images/phone.png" width="20" /></div>
//                 <div className="row_content ms-3">
//                   <label>Phone Number</label>
//                   <p>{profile?.Phone}</p>
//                 </div>
//               </div>
//             </div>

//             <div className="detail_row d-flex justify-content-between align-items-center">
//               <div className="d-flex align-items-center">
//                 <div className="row_icon"><img src="/images/mail.png" width="20" /></div>
//                 <div className="row_content ms-3">
//                   <label>Email ID</label>
//                   <p>{profile?.Email || "Not Updated"}</p>
//                 </div>
//               </div>
//               <BsPencilSquare className="text-primary" onClick={toggleInput} style={{ cursor: 'pointer' }} />
//             </div>

//             {inputOpen && (
//               <div className="email_update_box mt-2">
//                 <input
//                   type="email"
//                   className="modern_input"
//                   placeholder="New Email Address"
//                   value={Email}
//                   onChange={handleEmailChange}
//                 />
//                 <button className="btn_update_email mt-2 w-100" onClick={UpdateEmail}>Update Email</button>
//               </div>
//             )}

//             {/* <div className="detail_row border-0 d-flex justify-content-between align-items-center" onClick={Kyc} style={{cursor:'pointer'}}>
//                 <div className="d-flex align-items-center">
//                    <div className="row_icon"><img src="/images/kyc.png" width="20"/></div>
//                    <div className="row_content ms-3 ml-3">
//                       <label>KYC Status</label>
//                       <p className={profile?.verified === "verified" ? "text-success" : "text-warning"}>
//                         {profile?.verified === "verified" ? "Verified User" : "Complete KYC Verification"}
//                       </p>
//                    </div>
//                 </div>
//                 <div className="arrow_right">{'>'}</div>
//              </div> */}
//            <div
//   className="detail_row border-0 d-flex justify-content-between align-items-center"
//   // Clickable only if NOT verified AND NOT pending
//   onClick={
//     profile?.verified === "verified" || profile?.verified === "pending"
//       ? null
//       : Kyc
//   }
//   style={{
//     cursor:
//       profile?.verified === "verified" || profile?.verified === "pending"
//         ? "default"
//         : "pointer",
//   }}
// >
//   <div className="d-flex align-items-center">
//     <div className="row_icon">
//       <img src="/images/kyc.png" width="20" alt="kyc" />
//     </div>
//     <div className="row_content ms-3 ml-3">
//       <label>KYC Status</label>
//       <p
//         className={
//           profile?.verified === "verified"
//             ? "text-success"
//             : profile?.verified === "pending"
//             ? "text-info" // Use info (blue) or primary for pending
//             : "text-warning"
//         }
//       >
//         {/* Dynamic Status Text */}
//         {profile?.verified === "verified"
//           ? "Verified"
//           : profile?.verified === "pending"
//           ? "Pending Verification"
//           : "Complete KYC Verification"}
//       </p>
//     </div>
//   </div>

//   <div className="arrow_right">
//     {/* Show arrow only if user is unverified (not verified and not pending) */}
//     {profile?.verified === "verified" || profile?.verified === "pending"
//       ? ""
//       : ">"}
//   </div>
// </div>
//           </div>

//           <div className="logout_container text-center mb-5">
//             <button className="premium_logout_btn" onClick={logout}>
//               <span>LOGOUT ACCOUNT</span>
//             </button>
//           </div>
//         </div>

//         {/* --- MODAL (Functionality Untouched, UI Cleaned) --- */}
//         <Modal show={showKyc} onHide={handleCloseKyc} centered className="dark_modal">
//           <Modal.Header closeButton className="border-0">
//             <Modal.Title style={{ color: "#000" }}>Verification Center</Modal.Title>
//           </Modal.Header>
//           <Modal.Body className="pt-0">
//             <ul className="nav nav-pills modern_tabs mb-3" id="kycTab" role="tablist">
//               {SData.onlineKYC && (
//                 <li className="nav-item flex-fill">
//                   <button className="nav-link active w-100" id="online-tab" data-bs-toggle="tab" data-bs-target="#online">Online</button>
//                 </li>
//               )}
//               {SData.offlineKYC && (
//                 <li className="nav-item flex-fill">
//                   <button className="nav-link w-100" id="offline-tab" data-bs-toggle="tab" data-bs-target="#offline"> Offline Kyc</button>
//                 </li>
//               )}
//             </ul>

//             <div className="tab-content mt-4">
//               {SData.onlineKYC && (
//                 <div className="tab-pane fade show active" id="online">
//                   <div className="form-group mb-3">
//                     <label className="small text-secondary">Aadhar Number</label>
//                     <input type="number" className="modern_input" value={AadharNum} onChange={handleAdharChnage} placeholder="12 Digit Aadhar" />
//                     <p className="text-danger small mt-1">{msg}</p>
//                   </div>
//                   {isLoading ? <div className="text-center"><img src='/images/LandingPage_img/loader1.gif' width="40" /></div> :
//                     userAdharData?.data?.status !== "SUCCESS" && <button className="btn_premium_modal w-100" onClick={AdharNumber}>Send OTP</button>
//                   }
//                   {userAdharData?.data?.status === "SUCCESS" && (
//                     <div className="mt-3">
//                       <input type="number" className="modern_input" value={AadharOtp} onChange={handleAdharOtpChnage} placeholder="Enter OTP" />
//                       <button className="btn_premium_modal w-100 mt-2" onClick={AdharOtpFunc}>Submit OTP</button>
//                     </div>
//                   )}
//                 </div>
//               )}
//               {SData.offlineKYC && (
//                 <div className="tab-pane fade" id="offline">
//                   <input type="text" className="modern_input mb-3" placeholder="Full Name" value={Names} onChange={(e) => setNames(e.target.value)} />
//                   <input type="text" className="modern_input mb-3" placeholder="Aadhar Number" value={AadharNum} onChange={handleAdharChnage} />
//                   <input type="date" className="modern_input mb-3" value={DOB} onChange={(e) => setDob(e.target.value)} />
//                   <div className="file_upload_area mb-3">
//                     <label>Front Photo</label>
//                     <input type="file" onChange={(e) => setFrontLoaded(e.target.files)} accept="image/*" />
//                   </div>
//                   <div className="file_upload_area mb-3">
//                     <label>Back Photo</label>
//                     <input type="file" onChange={(e) => setBackLoaded(e.target.files)} accept="image/*" />
//                   </div>
//                   <button className="btn_premium_modal w-100" onClick={handleSubmitdata}>Submit Verification</button>
//                 </div>
//               )}
//             </div>
//           </Modal.Body>
//         </Modal>
//       </div>

//       <div className="rightContainer">
//         <Rightcontainer />
//       </div>

//       <style dangerouslySetInnerHTML={{
//         __html: `
//         .premium_card { background: #1a1a2e; border-radius: 15px; position: relative; overflow: hidden; border: 1px solid #2a2a45; box-shadow: 0 10px 30px rgba(0,0,0,0.5); }
//         .card_accent { position: absolute; top:0; left:0; width: 100%; height: 4px; background: linear-gradient(90deg, #f39c12, #e67e22); }
//         .main_profile_img { width: 70px; height: 70px; border-radius: 50%; border: 3px solid #f39c12; object-fit: cover; }
//         .camera_badge { position: absolute; bottom: 0; right: 0; background: #f39c12; border-radius: 50%; padding: 4px; border: 2px solid #1a1a2e; }
//         .profile_name_text { font-size: 1.2rem; font-weight: 700; color: #fff; margin-left: 10px; }
//         .badge_verified { background: rgba(46, 204, 113, 0.2); color: #2ecc71; border: 1px solid #2ecc71; padding: 4px 10px; border-radius: 20px; font-size: 10px; font-weight: 800; }
//         .badge_pending { background: rgba(231, 76, 60, 0.2); color: #e74c3c; border: 1px solid #e74c3c; padding: 4px 10px; border-radius: 20px; font-size: 10px; font-weight: 800; cursor:pointer; }
//         .stats_grid_premium { display: grid; grid-template-columns: 1fr 1fr; gap: 15px; }
//         .stat_item { background: #1a1a2e; padding: 15px; border-radius: 12px; display: flex; align-items: center; border: 1px solid #2a2a45; }
//         .stat_item img { width: 35px; height: 35px; margin-right: 12px; }
//         .stat_label { font-size: 10px; color: #888; text-transform: uppercase; display: block; }
//         .stat_val { font-size: 1.1rem; font-weight: 800; margin: 0; color: #fff; }
//         .blue_glow { border-left: 4px solid #3498db; }
//         .gold_glow { border-left: 4px solid #f1c40f; }
//         .green_glow { border-left: 4px solid #2ecc71; }
//         .purple_glow { border-left: 4px solid #9b59b6; }
//         .account_details_card { background: #000; border-radius: 15px; border: 1px solid #2a2a45; }
//         .section_title { font-size: 0.9rem; font-weight: 700; color: #f39c12; text-transform: uppercase; margin-bottom: 15px; }
//         .detail_row { padding: 12px 0; border-bottom: 1px solid #2a2a45; }
//         .row_icon { width: 40px; height: 40px; background: #252545; border-radius: 10px; display: flex; align-items: center; justify-content: center; }
//         .row_content label { font-size: 10px; color: #888; margin:0; }
//         .row_content p { font-size: 14px; color: #fff; margin:0; font-weight: 600; }
//         .modern_input { background: #ffff; border: 1px solid #2a2a45; color: #000; padding: 10px; border-radius: 8px; width: 100%; outline: none; transition: 0.3s; }
//         .modern_input:focus { border-color: #f39c12; box-shadow: 0 0 10px rgba(243, 156, 18, 0.2); }
//         .premium_logout_btn { background: linear-gradient(90deg, #e74c3c, #c0392b); color: #fff; border: none; padding: 12px 40px; border-radius: 30px; font-weight: 800; letter-spacing: 1px; width: 80%; transition: 0.3s; }
//         .premium_logout_btn:hover { transform: translateY(-2px); box-shadow: 0 5px 15px rgba(231, 76, 60, 0.4); }
//         .modern_tabs .nav-link { background: #0f0f1b; color: #888; border: 1px solid #2a2a45; margin: 0 5px; font-size: 14px; font-weight: 600; }
//         .modern_tabs .nav-link.active { background: #f39c12 !important; color: #fff; border-color: #f39c12; }
//         .btn_premium_modal { background: #f39c12; color: #fff; border: none; padding: 10px; border-radius: 8px; font-weight: 700; }
//         .dark_modal .modal-content { background: #1a1a2e; color: #fff; border: 1px solid #2a2a45; border-radius: 20px; }
//         .file_upload_area { border: 2px dashed #2a2a45; padding: 10px; border-radius: 10px; text-align: center; }
//         .file_upload_area label { font-size: 12px; color: #f39c12; display: block; }
//       `}} />
//     </>
//   );
// };

// export default Profile1;


import React, { useEffect, useRef, useState, useContext } from "react";
import { Link, useHistory } from "react-router-dom";
import Swal from "sweetalert2";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { LanguageContext } from "../Components/LanguageContext";
import { useTheme } from "../../ThemeContext";
import { BsPerson, BsPencilSquare, BsCheckCircleFill, BsShieldCheck, BsShieldExclamation } from 'react-icons/bs';
import { LuIndianRupee } from "react-icons/lu";
import { apiRequest } from "../../apiService/allApi";
import Rightcontainer from "../Components/Rightcontainer";

// Keep your CSS imports
import "../css/layout.css";
import css from "../css/Profile.module.css";
import "../css/kyc.css";
import "../css/Loader.css";

const Profile1 = ({ profile }) => {
  const translations = {
    hi: { wallet: 'वॉलेट', refer: 'किसी मित्र का रेफर कोड इस्तेमाल करे', win: 'पैसा जिता', game: 'गेम खेला', referEarn: 'रेफरल कमाई', referPerson: 'आमंत्रित किये दोस्त' },
    en: { wallet: 'My Wallet', refer: 'Use Refer Code', Win: 'Coin Won', game: 'Battle Played', referEarn: 'Referral Earning', referPerson: 'Referred Players' },
  };

  const { language } = useContext(LanguageContext);
  const baseUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const [show, setShow] = useState(false);
  const [show1, setShow1] = useState(false);
  const handleClose = () => setShow1(false);
  const handleShow = () => setShow1(true);
  const [referral, setCode] = useState("");
  const [Id, setId] = useState(null);
  const [msg, setMsg] = useState("");
  const [portcss, setPortcss] = useState(css.active_tab);
  const [portcss1, setPortcss1] = useState(css.inactive_tab);
  const [holder_name, setHolder_name] = useState();
  const [account_number, setAccount_number] = useState();
  const [ifsc_code, setIfsc_code] = useState();
  const [upi_id, setUpi_id] = useState();
  const [isLoading, setIsloading] = useState(false);
  const [showKyc, setShowKyc] = useState(false);
  const [process1, setProcesss] = useState(false);

  const udata = localStorage.getItem("udata");
  const profileData = JSON.parse(udata);
  const siteData = localStorage.getItem("sitSetting");
  const SData = JSON.parse(siteData);

  const handleCloseKyc = () => setShowKyc(false);
  const handleShowKyc = () => setShowKyc(true);
  const [inputOpen, setInputOpen] = useState(false);
  const [Email, setEmail] = useState(null);
  const toggleInput = () => setInputOpen(!inputOpen);
  const history = useHistory();

  const logout = async () => {
    localStorage.clear();
    let access_token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${access_token}` };
    await apiRequest(`me`, "GET", null, headers)
      .then(() => { /* logic */ })
      .catch((e) => {
        if (e.response?.status === 401) {
          localStorage.removeItem("token");
          window.location.reload();
          history.push("/login");
        }
      });
  };

  const UpdateEmail = async () => {
    const access_token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${access_token}` };
    if (Email != null) {
      try {
        const respone = await apiRequest(`user/profile/edit`, "PATCH", { Email }, headers);
        if (respone.data.status === false) {
          Swal.fire({ title: respone.data.msg, icon: "error" });
        } else {
          setEmail(respone.data); setInputOpen(false);
          Swal.fire({ title: respone.data.msg, icon: "success" });
        }
      } catch (error) { }
    } else {
      Swal.fire({ title: "Please enter your Email", icon: "error" });
    }
  };

  const [Name, setName] = useState(null);
  const UpdateProfile = async () => {
    const access_token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${access_token}` };
    if (Name != null) {
      const respone = await apiRequest(`user/profile/edit`, "PATCH", { Name }, headers);
      if (respone.data.status === false) {
        Swal.fire({ title: respone.data.msg, icon: "error" });
      } else {
        setName(respone.data);
        Swal.fire({ title: respone.data.msg, icon: "success" });
      }
    }
  };

  const [total, setTotal] = useState();
  const TotalGame = async () => {
    let access_token = localStorage.getItem("token");
    let userId = localStorage.getItem("userId");
    const headers = { Authorization: `Bearer ${access_token}` };
    try {
      const res = await apiRequest(`total/user/all/${userId}`, "GET", null, headers);
      if (res.data) setTotal(res.data);
    } catch (e) { }
  };

  const Result = async (file) => {
    if (file) {
      const access_token = localStorage.getItem("token");
      const headers = { Authorization: `Bearer ${access_token}` };
      const formData = new FormData();
      formData.append("avatar", file);
      await apiRequest(`users/me/avatar`, "POST", formData, headers);
    }
  };

  const Kyc = () => setShowKyc(true);

  const [AadharNum, setAadharNum] = useState("");
  const [userAdharData, setUserAdharData] = useState("");
  const handleAdharChnage = (e) => setAadharNum(e.target.value);

  const AdharNumber = async (e) => {
    setIsloading(true); e.preventDefault();
    if (/^[0-9]{12}$/.test(AadharNum)) {
      const access_token = localStorage.getItem("token");
      const headers = { Authorization: `Bearer ${access_token}` };
      const data = { aadharNumber: AadharNum };
      try {
        const res = await apiRequest("aadharcard-auto", "POST", data, headers);
        setUserAdharData(res?.data);
        setIsloading(false);
        if (res.data.status === false) setMsg(res?.data?.msg);
        else setMsg(res?.data?.data?.message);
      } catch (error) { console.log(error); }
    } else {
      Swal.fire({ icon: "error", title: "Invalid Aadhar", text: "12-digit required" });
      setIsloading(false);
    }
  };

  const [AadharOtp, setAadharOtp] = useState("");
  const [isLoading1, setIsloading1] = useState(false);
  const handleAdharOtpChnage = (e) => setAadharOtp(e.target.value);

  const AdharOtpFunc = async (e) => {
    setIsloading1(true);
    const access_token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${access_token}` };
    const data = { aadharNumber: AadharNum, otp: AadharOtp, Email: Email, transaction_id: userAdharData.data?.ref_id };
    try {
      const res = await apiRequest(`aadharcard-auto-verify`, "POST", data, headers);
      setIsloading1(false);
      if (res.data.status === false) setMsg(res.data?.msg);
      else window.location.reload();
    } catch (e) { console.log(e); }
  };

  let aadharProcess = useRef(false);
  const [Names, setNames] = useState("");
  const [DOB, setDob] = useState("");
  const [frontLoaded, setFrontLoaded] = useState(null);
  const [backLoaded, setBackLoaded] = useState(null);

  const handleSubmitdata = async (e) => {
    e.preventDefault();
    if (!Names || !DOB || !frontLoaded || !backLoaded || !AadharNum) {
      alert("All fields required"); return;
    }
    if (aadharProcess.current === false) {
      setProcesss(true); aadharProcess.current = true;
      const formData = new FormData();
      formData.append("Name", Names); formData.append("DOB", DOB);
      formData.append("front", frontLoaded[0]); formData.append("back", backLoaded[0]);
      formData.append("Number", AadharNum); formData.append("Email", Email);
      const access_token = localStorage.getItem("token");
      const headers = { Authorization: `Bearer ${access_token}` };
      const res = await apiRequest(`aadharcard`, "POST", formData, headers);
      if (res.data.status === false) {
        Swal.fire({ title: res.data.msg, icon: "error" }).then(() => handleCloseKyc());
      } else {
        Swal.fire({ title: "KYC submitted", icon: "success" }).then(() => handleCloseKyc());
        history.push("/Profile");
      }
      aadharProcess.current = false; setProcesss(false);
    }
  };

  useEffect(() => { TotalGame(); }, []);

  const [isValidEmail, setIsValidEmail] = useState(true);
  const handleEmailChange = (e) => {
    const newEmail = e.target.value;
    setEmail(newEmail);
    const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
    setIsValidEmail(emailRegex.test(newEmail) && newEmail.toLowerCase().endsWith(".com"));
  };

  const theme = localStorage.getItem('theme');
  const styles = {
    backgroundColor: theme === 'light' ? '#f8f9fa' : '#0a0a0f',
    color: theme === 'light' ? '#333' : '#fff',
  };

  return (
    <>
      <div className="leftContainer mt-4 mb_space" style={{ ...styles, minHeight: "100vh" }}>
        <div className="profile_page_modern pt-4 px-3 pb-5">

          {/* 1. Header Card (Modern Glassmorphic Look) */}
          <div className="modern_card profile_header_card mb-4">
            <div className="modern_card_cover"></div>
            <div className="d-flex align-items-center p-4 position-relative z-1">
              <div className="modern_avatar_container">
                <label style={{ cursor: 'pointer', margin: 0 }}>
                  <input type="file" className="d-none" accept="image/*" onChange={(e) => Result(e.target.files[0])} />
                  <img
                    src={profileData?.avatar ? `${baseUrl}/${profileData.avatar}` : "./images/avatars/Avatar3.png"}
                    alt="User"
                    className="modern_profile_img shadow-sm"
                  />
                  <div className="modern_camera_badge shadow"><BsPencilSquare size={14} /></div>
                </label>
              </div>
              <div className="ms-4 flex-grow-1">
                {portcss === css.active_tab ? (
                  <div className="d-flex align-items-center mb-1">
                    <h2 className="modern_profile_name mb-0">{profile?.Name || "Player"}</h2>
                    <button className="modern_icon_btn ms-2" onClick={() => { setPortcss(css.inactive_tab); setPortcss1(css.active_tab); }}>
                      <BsPencilSquare size={16} />
                    </button>
                  </div>
                ) : (
                  <div className="d-flex mb-2">
                    <input
                      type="text"
                      className="modern_edit_input"
                      value={Name}
                      placeholder="Enter Name"
                      onChange={(e) => setName(e.target.value)}
                    />
                    <button className="modern_save_btn ms-2 shadow-sm" onClick={() => { setPortcss(css.active_tab); setPortcss1(css.inactive_tab); UpdateProfile(); }}>
                      <BsCheckCircleFill size={18} />
                    </button>
                  </div>
                )}

                <div className="kyc_modern_status mt-2">
                  {profile?.verified === "verified" ? (
                    <span className="modern_badge verified shadow-sm"><BsShieldCheck className="me-1"/> Verified Player</span>
                  ) : (
                    <span className="modern_badge unverified shadow-sm" onClick={Kyc}><BsShieldExclamation className="me-1"/> Verification Pending</span>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* 2. Stats Grid */}
          <div className="modern_stats_grid mb-4">
            <div className="modern_stat_card blue_gradient shadow-sm">
              <div className="stat_icon_wrapper"><img src="/images/crossswords.png" alt="Games" /></div>
              <div className="stat_content">
                <span className="modern_stat_label">{translations[language].game}</span>
                <h3 className="modern_stat_value">{String(total?.stringValue ?? total ?? "0")}</h3>
              </div>
            </div>
            <div className="modern_stat_card gold_gradient shadow-sm">
              <div className="stat_icon_wrapper"><img src="/Coin without Glow.gif" alt="Coins" /></div>
              <div className="stat_content">
                <span className="modern_stat_label">{translations[language].Win}</span>
                <h3 className="modern_stat_value">₹{String(profile?.wonAmount?.stringValue ?? "0")}</h3>
              </div>
            </div>
          </div>

          {/* 3. Account Details List */}
          <div className="modern_card details_card p-4 mb-4 shadow-sm">
            <h4 className="modern_section_title mb-4">Account Information</h4>

            <div className="modern_detail_row">
              <div className="d-flex align-items-center">
                <div className="modern_row_icon"><img src="/images/phone.png" alt="Phone" /></div>
                <div className="modern_row_content ms-3">
                  <label>Phone Number</label>
                  <p>{profile?.Phone}</p>
                </div>
              </div>
            </div>

            <div className="modern_detail_row">
              <div className="d-flex align-items-center w-100 justify-content-between">
                <div className="d-flex align-items-center">
                  <div className="modern_row_icon"><img src="/images/mail.png" alt="Mail" /></div>
                  <div className="modern_row_content ms-3">
                    <label>Email Address</label>
                    <p>{profile?.Email || "Not Updated"}</p>
                  </div>
                </div>
                <button className="modern_icon_btn" onClick={toggleInput}>
                  <BsPencilSquare size={18} />
                </button>
              </div>
              
              {inputOpen && (
                <div className="modern_email_update_box mt-3">
                  <div className="d-flex gap-2">
                    <input
                      type="email"
                      className="modern_form_input flex-grow-1"
                      placeholder="Enter new email address"
                      value={Email}
                      onChange={handleEmailChange}
                    />
                    <button className="modern_btn_primary shadow-sm" onClick={UpdateEmail}>Update</button>
                  </div>
                </div>
              )}
            </div>

            <div
              className="modern_detail_row border-0 mb-0"
              onClick={profile?.verified === "verified" || profile?.verified === "pending" ? null : Kyc}
              style={{ cursor: profile?.verified === "verified" || profile?.verified === "pending" ? "default" : "pointer" }}
            >
              <div className="d-flex align-items-center justify-content-between w-100">
                <div className="d-flex align-items-center">
                  <div className="modern_row_icon"><img src="/images/kyc.png" alt="KYC" /></div>
                  <div className="modern_row_content ms-3">
                    <label>KYC Verification</label>
                    <p className={`status_text ${profile?.verified === "verified" ? "text_success" : profile?.verified === "pending" ? "text_info" : "text_warning"}`}>
                      {profile?.verified === "verified" ? "Verified" : profile?.verified === "pending" ? "Pending Verification" : "Complete KYC Now"}
                    </p>
                  </div>
                </div>
                <div className="modern_arrow_right">
                  {profile?.verified === "verified" || profile?.verified === "pending" ? "" : <i className="fas fa-chevron-right"></i>}
                </div>
              </div>
            </div>
          </div>

          <div className="text-center mt-5">
            <button className="modern_logout_btn shadow" onClick={logout}>
              Secure Logout
            </button>
          </div>
        </div>

        {/* --- MODAL --- */}
        <Modal show={showKyc} onHide={handleCloseKyc} centered className="modern_modal">
          <Modal.Header closeButton className="border-0 pb-0">
            <Modal.Title className="modern_modal_title w-100 text-center mt-2">Verification Center</Modal.Title>
          </Modal.Header>
          <Modal.Body className="px-4 pb-4 pt-3">
            <ul className="nav nav-pills modern_nav_pills mb-4" id="kycTab" role="tablist">
              {SData.onlineKYC && (
                <li className="nav-item flex-fill">
                  <button className="nav-link active w-100" id="online-tab" data-bs-toggle="tab" data-bs-target="#online">Fast Verification</button>
                </li>
              )}
              {SData.offlineKYC && (
                <li className="nav-item flex-fill">
                  <button className="nav-link w-100" id="offline-tab" data-bs-toggle="tab" data-bs-target="#offline">Manual Upload</button>
                </li>
              )}
            </ul>

            <div className="tab-content">
              {SData.onlineKYC && (
                <div className="tab-pane fade show active" id="online">
                  <div className="form-group mb-4">
                    <label className="modern_input_label">Aadhar Number</label>
                    <input type="number" className="modern_form_input w-100" value={AadharNum} onChange={handleAdharChnage} placeholder="Enter 12-digit number" />
                    {msg && <p className="modern_error_text mt-2 mb-0">{msg}</p>}
                  </div>
                  {isLoading ? (
                    <div className="text-center py-3"><img src='/images/LandingPage_img/loader1.gif' width="40" alt="Loading"/></div>
                  ) : (
                    userAdharData?.data?.status !== "SUCCESS" && <button className="modern_btn_primary w-100 py-2 shadow-sm" onClick={AdharNumber}>Generate OTP</button>
                  )}
                  {userAdharData?.data?.status === "SUCCESS" && (
                    <div className="mt-4 pt-3 border-top modern_border_divider">
                      <label className="modern_input_label">Verification Code</label>
                      <input type="number" className="modern_form_input w-100 mb-3" value={AadharOtp} onChange={handleAdharOtpChnage} placeholder="Enter OTP received" />
                      <button className="modern_btn_primary w-100 py-2 shadow-sm" onClick={AdharOtpFunc}>Verify Account</button>
                    </div>
                  )}
                </div>
              )}
              {SData.offlineKYC && (
                <div className="tab-pane fade" id="offline">
                  <div className="form-group mb-3">
                    <input type="text" className="modern_form_input w-100" placeholder="Full Legal Name" value={Names} onChange={(e) => setNames(e.target.value)} />
                  </div>
                  <div className="form-group mb-3">
                    <input type="text" className="modern_form_input w-100" placeholder="Aadhar Number" value={AadharNum} onChange={handleAdharChnage} />
                  </div>
                  <div className="form-group mb-4">
                    <input type="date" className="modern_form_input w-100" value={DOB} onChange={(e) => setDob(e.target.value)} />
                  </div>
                  
                  <div className="row g-3 mb-4">
                    <div className="col-6">
                      <div className="modern_file_upload">
                        <label className="w-100">
                          <span className="d-block mb-1">Front Image</span>
                          <span className="upload_subtext">Tap to upload</span>
                          <input type="file" className="d-none" onChange={(e) => setFrontLoaded(e.target.files)} accept="image/*" />
                        </label>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="modern_file_upload">
                        <label className="w-100">
                          <span className="d-block mb-1">Back Image</span>
                          <span className="upload_subtext">Tap to upload</span>
                          <input type="file" className="d-none" onChange={(e) => setBackLoaded(e.target.files)} accept="image/*" />
                        </label>
                      </div>
                    </div>
                  </div>
                  <button className="modern_btn_primary w-100 py-2 shadow-sm" onClick={handleSubmitdata}>Submit Documents</button>
                </div>
              )}
            </div>
          </Modal.Body>
        </Modal>
      </div>

      <div className="rightContainer">
        <Rightcontainer />
      </div>

      <style dangerouslySetInnerHTML={{
        __html: `
        /* --- Modern Profile UI Variables & Base --- */
        :root {
          --card-bg: #151924;
          --card-border: rgba(255, 255, 255, 0.05);
          --text-main: #f8fafc;
          --text-muted: #94a3b8;
          --accent-blue: #3b82f6;
          --accent-blue-hover: #2563eb;
          --accent-gold: #f59e0b;
          --success: #10b981;
          --warning: #f59e0b;
          --danger: #ef4444;
          --info: #0ea5e9;
          --input-bg: rgba(15, 23, 42, 0.6);
        }

        /* Adjustments for light theme injected dynamically if needed, defaults to premium dark */
        .profile_page_modern { font-family: 'Inter', -apple-system, sans-serif; }
        
        .modern_card {
          background: var(--card-bg);
          border: 1px solid var(--card-border);
          border-radius: 20px;
          position: relative;
          overflow: hidden;
        }

        .profile_header_card { min-height: 140px; }
        .modern_card_cover {
          position: absolute;
          top: 0; left: 0; right: 0; height: 60px;
          background:linear-gradient(135deg, rgb(255 70 121 / 78%), rgb(16 185 129 / 91%));
          border-bottom: 1px solid rgba(255,255,255,0.03);
        }

        .modern_avatar_container { position: relative; display: inline-block; }
        .modern_profile_img {
          width: 85px; height: 85px;
          border-radius: 50%;
          border: 4px solid var(--card-bg);
          object-fit: cover;
          background: #1e293b;
        }
        .modern_camera_badge {
          position: absolute;
          bottom: 4px; right: 4px;
          background: var(--accent-blue);
          color: white;
          width: 28px; height: 28px;
          border-radius: 50%;
          display: flex; align-items: center; justify-content: center;
          border: 3px solid var(--card-bg);
          transition: transform 0.2s;
        }
        .modern_avatar_container:hover .modern_camera_badge { transform: scale(1.1); }

        .modern_profile_name { font-size: 1.4rem; font-weight: 700; color: var(--text-main); letter-spacing: -0.5px; }
        
        .modern_icon_btn {
          background: transparent; border: none; color: var(--text-muted);
          padding: 4px; border-radius: 6px; transition: 0.2s;
          display: flex; align-items: center; justify-content: center;
        }
        .modern_icon_btn:hover { color: var(--accent-blue); background: rgba(59,130,246,0.1); }

        .modern_edit_input {
          background: var(--input-bg); border: 1px solid rgba(255,255,255,0.1);
          color: var(--text-main); padding: 6px 12px; border-radius: 8px;
          font-size: 1rem; width: 100%; max-width: 200px; outline: none;
        }
        .modern_edit_input:focus { border-color: var(--accent-blue); }
        
        .modern_save_btn {
          background: var(--success); color: white; border: none;
          border-radius: 8px; width: 36px; height: 36px;
          display: flex; align-items: center; justify-content: center; transition: 0.2s;
        }
        .modern_save_btn:hover { background: #059669; }

        .modern_badge {
          display: inline-flex; align-items: center;
          padding: 5px 12px; border-radius: 20px; font-size: 0.75rem; font-weight: 600; letter-spacing: 0.5px;
        }
        .modern_badge.verified { background: rgba(16, 185, 129, 0.15); color: var(--success); border: 1px solid rgba(16, 185, 129, 0.3); }
        .modern_badge.unverified { background: rgba(245, 158, 11, 0.15); color: var(--warning); border: 1px solid rgba(245, 158, 11, 0.3); cursor: pointer; }

        .modern_stats_grid { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; }
        .modern_stat_card {
          background: var(--card-bg); border-radius: 16px; padding: 16px;
          display: flex; align-items: center; border: 1px solid var(--card-border);
          transition: transform 0.2s;
        }
        .modern_stat_card:hover { transform: translateY(-2px); }
        .stat_icon_wrapper {
          width: 48px; height: 48px; border-radius: 12px;
          display: flex; align-items: center; justify-content: center; margin-right: 16px;
        }
        .blue_gradient .stat_icon_wrapper { background: linear-gradient(135deg, rgba(59, 130, 246, 0.2), rgba(37, 99, 235, 0.1)); }
        .gold_gradient .stat_icon_wrapper { background: linear-gradient(135deg, rgba(245, 158, 11, 0.2), rgba(217, 119, 6, 0.1)); }
        .modern_stat_card img { width: 26px; height: 26px; object-fit: contain; }
        .modern_stat_label { display: block; font-size: 0.75rem; color: var(--text-muted); text-transform: uppercase; font-weight: 600; margin-bottom: 2px; }
        .modern_stat_value { margin: 0; font-size: 1.25rem; font-weight: 700; color: var(--text-main); }

        .modern_section_title { font-size: 1.1rem; font-weight: 700; color: var(--text-main); }
        .modern_detail_row { padding: 16px 0; border-bottom: 1px solid var(--card-border); transition: 0.2s; }
        .modern_row_icon {
          width: 42px; height: 42px; border-radius: 12px;
          background: rgba(255,255,255,0.03); border: 1px solid rgba(255,255,255,0.05);
          display: flex; align-items: center; justify-content: center;
        }
        .modern_row_icon img { width: 20px; height: 20px; opacity: 0.8; }
        .modern_row_content label { display: block; font-size: 0.75rem; color: var(--text-muted); margin-bottom: 2px; font-weight: 500; }
        .modern_row_content p { margin: 0; font-size: 0.95rem; color: var(--text-main); font-weight: 600; }
        .status_text.text_success { color: var(--success); }
        .status_text.text_warning { color: var(--warning); }
        .status_text.text_info { color: var(--info); }
        .modern_arrow_right { color: var(--text-muted); opacity: 0.5; font-size: 0.9rem; }

        .modern_form_input {
           border: 1px solid #000;
          color: #000; padding: 12px 16px; border-radius: 10px;
          font-size: 0.95rem; outline: none; transition: 0.2s;
        }
        .modern_form_input:focus { border-color: var(--accent-blue); box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1); }
        .modern_form_input::placeholder { color: #64748b; }
        
        .modern_btn_primary {
          background: var(--accent-blue); color: #fff; border: none;
          padding: 12px 20px; border-radius: 10px; font-weight: 600;
          font-size: 0.95rem; transition: 0.2s;
        }
        .modern_btn_primary:hover { background: var(--accent-blue-hover); transform: translateY(-1px); }

        .modern_logout_btn {
          background: rgba(239, 68, 68, 0.1); color: var(--danger); border: 1px solid rgba(239, 68, 68, 0.2);
          padding: 14px 40px; border-radius: 30px; font-weight: 700; font-size: 0.95rem;
          letter-spacing: 0.5px; transition: 0.3s; width: 80%; max-width: 300px;
        }
        .modern_logout_btn:hover { background: var(--danger); color: #fff; transform: translateY(-2px); box-shadow: 0 10px 20px rgba(239, 68, 68, 0.3); }

        /* Modal Styles */
        .modern_modal .modal-content { background: var(--card-bg); border: 1px solid var(--card-border); border-radius: 20px; }
        .modern_modal .btn-close { filter: invert(1) grayscale(100%) brightness(200%); opacity: 0.5; }
        .modern_modal_title { color: var(--danger); font-weight: 700; font-size: 1.25rem; }
        .modern_input_label { display: block; font-size: 0.8rem; color: var(--text-muted); margin-bottom: 6px; font-weight: 500; }
        .modern_error_text { color: var(--danger); font-size: 0.8rem; }
        .modern_border_divider { border-color: var(--card-border) !important; }

        .modern_nav_pills { background: rgba(255,255,255,0.03); padding: 4px; border-radius: 12px; }
        .modern_nav_pills .nav-link { color: var(--card-bg); font-weight: 600; padding: 10px; border-radius: 8px; transition: 0.2s;border: 2px dashed #000 }
        .modern_nav_pills .nav-link.active { background: var(--accent-blue); color: #fff; box-shadow: 0 2px 8px rgba(59, 130, 246, 0.3); }

        .modern_file_upload {
          background: rgba(239, 231, 231, 0.85); border: 2px dashed rgba(66, 3, 3, 0.72);
          border-radius: 12px; padding: 20px 10px; text-align: center; cursor: pointer; transition: 0.2s;
        }
        .modern_file_upload:hover { border-color: var(--accent-blue); background: rgba(59, 130, 246, 0.05); }
        .modern_file_upload span.d-block { color: var(--accent-blue); font-size: 0.9rem; font-weight: 600; }
        .modern_file_upload .upload_subtext { color: var(--text-muted); font-size: 0.75rem; }
        `}} />
    </>
  );
};

export default Profile1;